// extracted by mini-css-extract-plugin
export default {"container":"Disclaimer_container__ByyDx"};